import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Routes, Route, useNavigate } from "react-router-dom"
import { layoutTypes } from "./constants/layout"
// Import Routes all
import { authProtectedRoutes, publicRoutes, errorRoutes } from "./routes"

// Import all middleware
import Authmiddleware from "./routes/route"

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

import "./assets/scss/theme.scss"
import "react-toastify/dist/ReactToastify.css"

import { ToastContainer } from "react-toastify"

import Pages401 from "pages/Utility/pages-401"
import { getMainPrivillage, getSettings } from "store/actions"

const getLayout = layoutType => {
  let Layout = VerticalLayout
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      Layout = VerticalLayout
      break
    case layoutTypes.HORIZONTAL:
      Layout = HorizontalLayout
      break
    default:
      break
  }
  return Layout
}

const App = () => {
  const [mainPrivillage, setMainPrivillage] = useState([])
  const [settingData, setSettingData] = useState(0)
  const layoutType = useSelector(state => state.Layout.layoutType)
  const {mainPrivillageData, getSettingsData} = useSelector(
    state => state.privillage
  )
  const Layout = getLayout(layoutType)
  const dispatch = useDispatch()

  useEffect(() => {
    if(JSON.parse(localStorage.getItem("authUser"))) {
      dispatch(
        getMainPrivillage(JSON.parse(localStorage.getItem("authUser")).pkEmpId)
      )
      dispatch(getSettings())
    // setMainPrivillage(JSON.parse(localStorage.getItem("mainPrivileges")))
    }
  }, [])

  useEffect(() => {
    getSettingsData.length && setSettingData(getSettingsData[0].PK_Setting_ID)
    getSettingsData.length && console.log(getSettingsData[0].PK_Setting_ID)
  }, [getSettingsData])

  useEffect(() => {
    mainPrivillageData &&
      mainPrivillageData.length &&
      setMainPrivillage(mainPrivillageData)
  }, [mainPrivillageData])

  return (
    <React.Fragment>
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <NonAuthLayout>
                <ToastContainer theme="colored" />

                {route.component}
              </NonAuthLayout>
            }
            key={idx}
            exact={true}
          />
        ))}
        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <Authmiddleware>
                <ToastContainer theme="colored" />

                <Layout>
                  {(mainPrivillage.length && settingData !== 0) &&
                    (mainPrivillage.some(
                      privilege => ((privilege.PK_Page_ID === route.pageId && route.stockSetting <= settingData) )
                    ) ? (
                      route.component
                    ) : (
                      <Pages401 />
                    ))}
                </Layout>
              </Authmiddleware>
            }
            key={idx}
            exact={true}
          />
        ))}
        {errorRoutes.map((route, idx) => (
          <Route
            path={route.path}
            key={idx}
            element={<>{route.component}</>}
            exact={true}
          />
        ))}
      </Routes>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

export default App
